import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterObject } from '../filter-object';
import * as moment from 'moment-timezone';
import { StringHelper } from '../string-helper';

@Component({
  selector: 'filter-input',
  templateUrl: './filter-input.component.html',
  styleUrls: ['./filter-input.component.scss'],
})
export class FilterInputComponent implements OnInit {
  @Input()
  public filterObject: FilterObject;
  @Input()
  public isDate: boolean;

  @Output()
  public toggleFilterEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  public filterValueChanged: EventEmitter<any> = new EventEmitter<any>();

  public filterClicked = false;

  constructor() {}

  ngOnInit() {}

  public handleFilter(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  public toggleFilter(event?: Event) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.filterClicked = !this.filterObject.active;
    this.filterObject.value = '';
    this.toggleFilterEmitter.emit(this.filterObject.key);
  }

  public toggleEmptyFilter(event?: FocusEvent) {
    if (
      StringHelper.isEmptyOrWhiteSpace(this.filterObject.value) &&
      !(
        event != null &&
        event.relatedTarget != null &&
        event.relatedTarget['ariaLabel'] != null &&
        event.relatedTarget['ariaLabel'] == 'Open calendar'
      )
    ) {
      this.toggleFilter(event);
    }
  }

  public onFilterValueChange(filterValue: any): void {
    if (this.isDate) {
      if ((<HTMLInputElement>filterValue).value == null) {
        this.filterClicked = !this.filterObject.active;
        this.filterObject.displayValue = null;
        this.filterObject.value = '';
        this.toggleFilterEmitter.emit(this.filterObject.key);
        return;
      } else {
        this.filterObject.displayValue = (<HTMLInputElement>filterValue).value;
        this.filterObject.value = moment
          .tz(this.filterObject.displayValue, 'Europe/Brussels')
          .format('YYYYMMDD');
      }
    } else {
      this.filterObject.value = (<HTMLInputElement>filterValue).value;
    }
    this.filterValueChanged.emit(this.filterObject);
  }
}
